module.exports = __webpack_public_path__ + "img/send.4157c3f5.svg";